<!--
 * @Description: 输入框组件
 * @Autor: lwq
 * @Date: 2020-07-04 16:52:01
 * @最后编辑: Betway
 * @最后修改时间: 2022-07-05 10:54:11
-->
<template>
  <div class="inputBoxss" style="width: 100%">
    <v-text-field
      v-if="!textarea"
      :filled="filled"
      :readonly="readonly"
      :label="label"
      :value="value"
      :append-icon="appendIcon"
      :autofocus="autofocus"
      :background-color="backgroundColor ? backgroundColor : bgdColors"
      :clearIcon="clearIcon"
      :clearable="clearable"
      :color="color"
      :counter="counter"
      :counterValue="counterValue"
      :dense="dense"
      :disabled="disabled"
      :height="height"
      :hint="hint"
      :id="id"
      :placeholder="
        placeholder
          ? removestar(placeholder)
          : readonly
          ? ' '
          : removestar(label)
      "
      :prefix="prefix"
      :prepend-icon="prependIcon"
      :reverse="reverse"
      :rules="rules"
      :error-messages="errorMessages"
      :suffix="suffix"
      :type="type"
      :rounded="rounded"
      :validate-on-blur="validateOnBlur"
      @change="change"
      @blur="blur"
      @click="click"
      @click:append="clickAppend"
      @input="input"
      @focus="focus"
      @click:clear="clickClear"
      @click:prepend="clickPrepred"
      @keyup.enter="keyupEnter"
    >
      <slot name="append" slot="append"> </slot>
    </v-text-field>
    <v-textarea
      v-else
      :filled="filled"
      :readonly="readonly"
      :label="label"
      :value="value"
      :append-icon="appendIcon"
      :autofocus="autofocus"
      :background-color="backgroundColor ? backgroundColor : bgdColors"
      :clearIcon="clearIcon"
      :clearable="clearable"
      :color="color"
      :counter="counter"
      :counterValue="counterValue"
      :dense="dense"
      :disabled="disabled"
      :height="height"
      :hint="hint"
      :id="id"
      :placeholder="
        placeholder
          ? removestar(placeholder)
          : readonly
          ? ' '
          : removestar(label)
      "
      :prefix="prefix"
      :prepend-icon="prependIcon"
      :reverse="reverse"
      :rules="rules"
      :error-messages="errorMessages"
      :suffix="suffix"
      :type="type"
      :rounded="rounded"
      :validate-on-blur="validateOnBlur"
      @change="change"
      @blur="blur"
      @click="click"
      @click:append="clickAppend"
      @input="input"
      @focus="focus"
      @click:clear="clickClear"
      @click:prepend="clickPrepred"
      @keydown="keydown"
      :auto-grow="true"
      row-height="40"
      :rows="rows"
    >
      <slot name="append" slot="append"> </slot>
    </v-textarea>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    rows: {
      type: [Number, String],
      default: 1,
    },
    textarea: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: undefined,
    },
    appendIcon: {
      type: String,
      default: undefined,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
    },
    clearIcon: {
      type: String,
      default: "$clear",
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: undefined,
    },
    counter: {
      type: [String, Number, Boolean],
      default: undefined,
    },
    counterValue: {
      type: Function,
      default: null,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    height: {
      type: [String, Number],
      default: undefined,
    },
    hint: {
      type: String,
      default: undefined,
    },
    hideDetails: {
      type: [String, Boolean],
      default: "auto",
    },
    id: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: undefined,
    },
    prefix: {
      type: String,
      default: undefined,
    },
    prependIcon: {
      type: String,
      default: undefined,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: [Array],
      default: () => [],
    },
    suffix: {
      type: String,
      default: undefined,
    },
    type: {
      type: String,
      default: "text",
    },
    validateOnBlur: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number, Array],
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  data() {
    return {
      bgdColors: "#f5f5f5",
      // rows: "1",
    };
  },
  created() {
    if (!this.backgroundColor) {
      if (!this.readonly) {
        this.bgdColors = "#f5f5f5";
      } else {
        this.bgdColors = "#ffffff";
      }
    } else {
      this.bgdColors = this.backgroundColor;
    }
  },
  mounted() {
    // if (!this.backgroundColor) {
    //   if (!this.readonly) {
    //     this.bgdColors = '#f5f5f5'
    //   }
    //   else {
    //     this.bgdColors = '#ffffff'
    //   }
    // }
    // else {
    //   this.bgdColors = this.backgroundColor
    // }
  },
  methods: {
    removestar(v) {
      return String(v).replace("*", "");
    },
    change(val) {
      this.$emit("change", val);
    },
    blur(val) {
      this.$emit("blur", val);
    },
    click(val) {
      this.$emit("click", val);
    },
    clickAppend(val) {
      this.$emit("click:append", val);
    },
    input(val) {
      this.$emit("input", val);
    },
    focus(val) {
      this.$emit("focus", val);
    },
    clickClear(val) {
      this.$emit("click:clear", val);
    },
    clickPrepred(val) {
      this.$emit("click:prepred", val);
    },
    keyupEnter(val) {
      this.$emit("keyupEnter", val);
    },
    keydown(val) {
      this.$emit("keydown", val);
    },
  },
  computed: {},
  watch: {
    readonly(v) {
      if (!this.backgroundColor) {
        if (!v) {
          this.bgdColors = "#f5f5f5";
        } else {
          this.bgdColors = "#ffffff";
        }
      } else {
        this.bgdColors = this.backgroundColor;
      }
    },
  },
};
</script>

<style scoped>
.inputBoxss /deep/ .v-text-field__slot input {
  min-height: 40px;
  padding-left: 8px;
  /* height: 40px;
  line-height: 40px;
   font-family: var(--body-font-family);

  font-style: normal;
  font-weight: normal;
  font-size: 16px; */
}
.inputBoxss /deep/ .v-input__slot {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.inputBoxss /deep/.v-input .v-label {
  top: 2px !important;
}
/deep/ textarea {
  line-height: 40px;
  padding-left: 8px;
}
/deep/ .v-input__append-inner {
  margin-right: 8px;
}
/* .inputBoxss /deep/ .v-text-field__slot label {
  font-family:var(--body-font-family);
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.38);
  padding-left: 8px;
} */
</style>
